export const AuthActionsTypes = {
  SET_LOGIN: "SET_LOGIN",
  SET_LOAD_STORE: "SET_LOAD_REDUX",
  SET_ERROR_LOGIN_STORE: "SET_ERROR_LOGIN_STORE",
  SET_ERROR_REGISTER: "SET_ERROR_REGISTER",
  SET_INSTAGRAM_AUTH: "SET_INSTAGRAM_AUTH",
  UPDATE_INSTAGRAM_AUTH: "UPDATE_INSTAGRAM_AUTH",
};
